<template>
  <v-text-field
      :data-vv-name="name"
      :data-vv-scope="scope"
      :data-vv-as="label"
      :error-messages="errorMessages"
      :label="label|capitalize"
      :name="name"
      :ref="name"
      :required="required"
      :value="value"
      @blur="onBlur($event)"
      @focus="onFocus()"
      @input="onInput($event)"
      class="nx-form-text"
      data-vv-value-path="value"
      v-validate="validation"
      data-vv-validate-on="input|blur"
      :disabled="disabled"
      v-bind="$attrs"
      type="number"
  >
    <template slot="prepend">
      <slot name="prepend"></slot>
    </template>
    <template slot="append">
      <slot name="append"></slot>
    </template>
    <template slot="append-outer">
      <slot name="append-outer"></slot>
    </template>
  </v-text-field>
</template>

<script>
import FormElement from '@/modules/form/mixins/form-element';

export default {
  name: 'nx-form-number',
  mixins: [FormElement],
  props: {
    value: {
      type: [String, Number],
    },
  },
  methods: {
    onInput($event) {
      const value = $event !== '' ? Number($event) : null;
      this.$emit('input', isNaN(value) ? null : value);
    },
  },
};
</script>
